(() => {
  const revealSelectors = [
    '.create-limited__label',
    '.create-limited__cards',
    '.create-limited__note',
    '.create-howto__heading',
    '.create-howto__steps',
    '.create-product',
    '.create-examples__heading',
    '.create-examples__item',
  ];

  const showImmediately = (page, revealElements) => {
    page.classList.add('is-loaded', 'is-create-hero-visible');
    revealElements.forEach((element) => element.classList.add('is-show'));
  };

  const initCreatePage = (page) => {
    if (page.dataset.createBound === 'true') return;

    page.dataset.createBound = 'true';
    page.classList.add('js-create-ready');

    const revealElements = [...page.querySelectorAll(revealSelectors.join(','))];
    revealElements.forEach((element) => element.classList.add('create-reveal'));

    if (!('IntersectionObserver' in window)) {
      showImmediately(page, revealElements);
      return;
    }

    window.setTimeout(() => page.classList.add('is-loaded'), 100);

    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-show');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    });

    revealElements.forEach((element) => revealObserver.observe(element));

    const hero = page.querySelector('.create-hero');
    if (hero) {
      const heroObserver = new IntersectionObserver((entries) => {
        page.classList.toggle('is-create-hero-visible', entries.some((entry) => entry.isIntersecting));
      }, { threshold: 0.05 });
      heroObserver.observe(hero);
    }
  };

  const init = (root = document) => {
    if (root.matches?.('.create-page')) initCreatePage(root);
    root.querySelectorAll?.('.create-page').forEach(initCreatePage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
